import { BREADCRUMB_STORE_ID } from '../constants'
import type { MenuBreadcrumb } from '../entities/MenuBreadcrumb'
import type { MenuBreadcrumbItems } from '../entities/MenuBreadcrumbItems'

export const useMenuBreadcrumbStore = () => {
  const state = useState<MenuBreadcrumb>(BREADCRUMB_STORE_ID, () => [])
  const getMenuBreadcrumb = (): MenuBreadcrumb => {
    return state.value
  }
  const setMenuBreadcrumb = (
    currentPageName: string,
    middleItems?: MenuBreadcrumbItems,
  ) => {
    const route = useRoute()
    const tempBreadCrumb: MenuBreadcrumb = []
    // First Element
    tempBreadCrumb.push({
      id: 'home',
      name: t('menu.breadcrumb.home'),
      href: routes().home(),
      selected: false,
    })
    // Middle Items
    if (middleItems) {
      middleItems.forEach((item, index) => {
        tempBreadCrumb.push({
          id: `item-${index}`,
          name: item.name,
          href: item.href,
          selected: false,
        })
      })
    }

    // Last Element --> Current Page
    tempBreadCrumb.push({
      id: 'current-page',
      name: currentPageName,
      href: route.path,
      selected: true,
    })

    state.value = tempBreadCrumb
  }

  const clearMenuBreadcrumb = () => {
    state.value = []
  }

  return {
    getMenuBreadcrumb,
    setMenuBreadcrumb,
    clearMenuBreadcrumb,
  }
}
